import { KEYS_BY_PRODUCT } from 'constants/features';

/**
  * Select the proper message key based on the user eligibility.
  * @param {Object} upsaleEligibility - Eligibility and script creation options.
  * @param {boolean} upsaleEligibility.canCreateScript - It indicates if a script can be created.
  * @param {Object} upsaleEligibility.eligibility - Eligibility options.
  * @param {string} upsaleEligibility.eligibility.eligibleProduct - The product that the user is eligible for.
  * @param {string} upsaleEligibility.eligibility.isFetchCompleted - It indicates if the options were fetched.
  * @return {string | null} - The message key or null.
  */
export const getMessageKeyByEligibility = (upsaleEligibility) => {
  const { eligibility, canCreateScript } = upsaleEligibility;
  
  if (!eligibility) {
    return null;
  }

  const baseKey = 'text__is-app-mode-upgrade-';
  let messageKey = eligibility.eligibleProduct && `${baseKey}${KEYS_BY_PRODUCT[eligibility.eligibleProduct]}`;

  if (eligibility.isFetchCompleted) {
    const shouldShowMessage = !canCreateScript && eligibility.eligibleProduct;
    messageKey = shouldShowMessage ? messageKey : null;
  } else {
    messageKey = null;
  }

  return messageKey;
};
